// TODO: check this after the requirements on the backend are final.

import { isValidEmail } from '#app/utilities/isValidEmail.js';

export const formatUrl = (url: string) => {
  const newUrl = url.trim();

  if (isValidEmail(newUrl)) {
    return `mailto:${newUrl}`;
  }

  if (!newUrl.startsWith('http://') && !newUrl.startsWith('https://')) {
    return `https://${newUrl}`;
  }

  return newUrl;
};
